import { HttpResponse } from '@angular/common/http';
import { extractFileNameFromContentDisposition } from './http-utils';

export function downloadBlobFile(
  response: HttpResponse<Blob>,
  name?: string,
  fileFormat = '.xlsx'
): void {
  const blob = response.body;
  const fullFileName = name
    ? name + fileFormat
    : extractFileNameFromContentDisposition(response.headers);
  const contentType =
    response.headers.get('content-type') || 'application/octet-stream';
  const url = window.URL.createObjectURL(
    new Blob([blob], { type: contentType })
  );

  const a = document.createElement('a');
  document.body.appendChild(a);
  a.setAttribute('style', 'display: none');
  a.setAttribute('target', 'blank');
  a.href = url;
  a.download = fullFileName;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}

export function toBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      const arrayBuffer = reader.result as ArrayBuffer;
      const bytes = new Uint8Array(arrayBuffer);
      const binary = String.fromCharCode(...bytes);
      const base64 = btoa(binary);
      resolve(base64);
    };
    reader.onerror = (error) => {
      let errorMessage: string;
      if (error instanceof ErrorEvent) {
        errorMessage = error.message;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      } else if (
        typeof error === 'object' &&
        error !== null &&
        'message' in error
      ) {
        errorMessage = (error as any).message;
      } else {
        errorMessage = JSON.stringify(error);
      }
      reject(new Error(errorMessage));
    };
  });
}
